module.exports = __webpack_public_path__ + "img/block2-1-mobile.4adb0c0b.jpg";